import { PREDEFINED_QUERIES } from '@app/config/media-queries';
import styled from 'styled-components';

export const Container = styled.div`
  box-shadow: 0px 4px 4px rgba(173, 181, 189, 0.25);
  margin-bottom: 20px;
  font-family: var(--font-family);

  @media screen and (${PREDEFINED_QUERIES.isTabletOrLess}) {
    margin: 0 15px 20px 15px;
  }
`;

export const TopBox = styled.div`
  display: flex;
  background-color: #25d366;
  padding: 10px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 3px 3px 0 0;

  & > span {
    color: #fff;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 17px;
  }

  & > button {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: none;
    border: none;
  }

  & > button:hover {
    cursor: pointer;
  }

  & > button > span {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    color: #ffffff;
    margin-right: 5px;
  }
`;

export const BottomBox = styled.div`
  background-color: #fff;
  padding: 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #868e96;
  border-radius: 0 0 3px 3px;
`;
